import SiteLayout from "../../SiteLayout";
import "../../styles/privacy.css";

export default function SitePrivacy() {
  return (
    <SiteLayout page="privacy" title="Privacy Policy | Shadow" navVariant="flat">
      <header className="legal-hero">
        <div className="wrap">
          <h1>Privacy Policy</h1>
          <div className="upd">Last updated · March 30, 2026</div>
        </div>
      </header>

      <div className="legal">
        <h2>1. Introduction</h2>
        <p>Converse AI Inc. (“Shadow”, “we”, “us”, or “our”) operates the Shadow meeting intelligence platform. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our service at shadowlabs.ai.</p>
        <h2>2. Information We Collect</h2>
        <p>When you use Shadow, we may collect the following information:</p>
        <ul>
          <li><b>Google Account Data:</b> Your name, email address, and profile picture via Google OAuth sign-in.</li>
          <li><b>Calendar Events:</b> Event titles, times, attendees, and meeting links from your Google Calendar (read-only access).</li>
          <li><b>Meeting Transcripts:</b> Real-time transcriptions of meetings where you have activated Shadow.</li>
          <li><b>AI-Generated Content:</b> Notes, summaries, follow-up questions, and action items generated by our AI based on your meeting data.</li>
          <li><b>Usage Data:</b> Anonymous analytics about how you interact with the platform.</li>
        </ul>
        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>To provide meeting preparation, live intelligence, and post-meeting summaries.</li>
          <li>To synchronize your calendar events and display upcoming meetings.</li>
          <li>To generate real-time insights, fact-checks, and coaching during live meetings.</li>
        </ul>
        <p><b>Google User Data:</b> We use Google user data (your name, email, profile picture, and calendar events) solely to provide Shadow's core functionality: meeting workflow, displaying your identity in the app, and generating meeting insights (preparation, live intelligence, and post-meeting summaries). We do not use Google user data for advertising, selling to third parties, training AI models, or any purpose other than delivering these features.</p>
        <h2>4. Third-Party Services</h2>
        <p>Shadow relies on subprocessors, including for meeting capture, AI processing, product analytics, and cloud infrastructure, to operate the service. They may process your information only as needed to provide Shadow and under contractual safeguards. When you connect Google sign-in or calendar, Google's handling of data you provide to Google is governed by Google's Privacy Policy.</p>
        <h2>5. Data Storage and Security</h2>
        <p>Your data is stored using encryption at rest and protected with HTTPS in transit. Access to your data is restricted to authenticated sessions only.</p>
        <h2>6. Data Retention and Deletion</h2>
        <p>We retain your data for as long as your account is active. You may request deletion of your account and all associated data at any time by contacting us at <a href="mailto:shubham@shadowlabs.ai">shubham@shadowlabs.ai</a>. Upon request, we will delete your data within 30 days.</p>
        <h2>7. Data Sharing</h2>
        <p>We do not sell, trade, or rent your personal information to third parties. We share data only with subprocessors and service providers who assist in operating the platform, strictly to deliver the functionality of Shadow. We do not transfer or disclose Google user data to third parties for advertising, data brokering, or any purpose other than delivering Shadow's functionality.</p>
        <h2>8. Your Rights</h2>
        <ul>
          <li>Access the personal data we hold about you.</li>
          <li>Request correction of inaccurate data.</li>
          <li>Request deletion of your data.</li>
          <li>Revoke Google OAuth access at any time via your Google Account settings.</li>
        </ul>
        <h2>9. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated policy on this page with a revised “Last updated” date.</p>
        <h2>10. Contact Us</h2>
        <p>If you have questions about this Privacy Policy, please contact us at <a href="mailto:shubham@shadowlabs.ai">shubham@shadowlabs.ai</a>.</p>
      </div>
    </SiteLayout>
  );
}
